import { GET } from "../adapters/xhr";
import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

export default function CreateGetCurrentUserInfoAction() {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        GET("Account/GetUserInfo")
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "CURRENT_USER_INFO_RECEIVED",
                        data: response.data
                    });
                }
                dispatch(CreateDataRetrievalEndedAction());
            })
            .catch(function () {
                dispatch({
                    type: "CURRENT_USER_INFO_RECEIVED",
                    data: { isAuthenticated: false, role: "", licenceApplications: [], vessels: [], ownerDashboardInformation: [], licenceTransfers: [] }
                });
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}